module.exports = __webpack_public_path__ + "img/7z.fe19b4a9.svg";